import { formatDate } from '@angular/common';
import { ElementRef, EventEmitter, NgZone, } from '@angular/core';
import cloneDeep from 'lodash.clonedeep';
import Sortable from 'sortablejs';
import { StressTestService } from 'StressTestsApp/ts/services/stress-test-service';
import { ConfirmModalComponent } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.component';
import { disablePointerEvents, enablePointerEvents } from 'NewAngular/utils/sortable-utils';
import * as i0 from "@angular/core";
import * as i1 from "StressTestsApp/ts/services/stress-test-service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i4 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i5 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i6 from "../stress-test-edit-modal/stress-test-edit-modal.component";
import * as i7 from "../stress-test-template-selector-modal/stress-test-template-selector-modal.component";
import * as i8 from "StressTestsApp/ts/features/stress-test-manage-modal/stress-test-manage-modal-list-item/stress-test-manage-modal-list-item.component";
const _c0 = ["confirmDeleteModal"];
const _c1 = ["sortableContainer"];
function StressTestManageModalComponent_ycn_stress_test_manage_modal_list_item_7_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-stress-test-manage-modal-list-item", 20);
    i0.ɵɵlistener("editHandler", function StressTestManageModalComponent_ycn_stress_test_manage_modal_list_item_7_Template_ycn_stress_test_manage_modal_list_item_editHandler_0_listener($event) { const i_r3 = i0.ɵɵrestoreView(_r2).index; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.editStressTest($event, i_r3)); })("deleteHandler", function StressTestManageModalComponent_ycn_stress_test_manage_modal_list_item_7_Template_ycn_stress_test_manage_modal_list_item_deleteHandler_0_listener() { const i_r3 = i0.ɵɵrestoreView(_r2).index; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.deleteStressTest(i_r3)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const stressTest_r5 = ctx.$implicit;
    i0.ɵɵproperty("stressTest", stressTest_r5);
} }
function StressTestManageModalComponent_p_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 21);
    i0.ɵɵtext(1, " No stress tests exist for this user. ");
    i0.ɵɵelementEnd();
} }
export class StressTestManageModalComponent {
    constructor(stressTestService, ngZone) {
        this.stressTestService = stressTestService;
        this.ngZone = ngZone;
        this.submitModalHandler = new EventEmitter();
        this.open = false;
        this.canUpdate = false;
    }
    ngOnInit() {
        // Avoid displaying data and errors when user is not logged in
        if (!window.USER.authenticated) {
            return;
        }
        this.stressTestService.getStressTestTemplates().subscribe((templates) => {
            this.stressTestTemplates = templates;
        });
    }
    ngAfterViewInit() {
        this.initializeSortable();
    }
    editStressTest(stressTest, index) {
        this.stressTestsToUpdate[index].name = stressTest.name;
        this.stressTestsToUpdate[index].start_date = stressTest.start_date;
        this.stressTestsToUpdate[index].end_date = stressTest.end_date;
        this.canUpdate = true;
    }
    deleteStressTest(index) {
        this.stressTestsToUpdate.splice(index, 1);
        this.canUpdate = true;
    }
    addStressTests(stressTests) {
        stressTests.forEach((stressTest) => {
            const exists = this.stressTestsToUpdate.find((st) => st.name === stressTest.name);
            if (!exists) {
                const startDate = formatDate(stressTest.start_date, 'M/d/yyyy', 'en-US', 'UTC');
                const endDate = stressTest.end_date
                    ? formatDate(stressTest.end_date, 'M/d/yyyy', 'en-US', 'UTC')
                    : 'Today';
                this.stressTestsToUpdate.push({
                    name: stressTest.name,
                    description: `(${startDate} - ${endDate})`,
                    start_date: stressTest.start_date,
                    end_date: stressTest.end_date,
                    order: this.stressTestsToUpdate.length,
                });
            }
        });
        this.canUpdate = true;
    }
    submitModal() {
        this.stressTestsToUpdate = this.stressTestsToUpdate.map((stressTest, index) => ({
            ...stressTest,
            order: index,
        }));
        this.stressTestService.updateStressTests({ stress_tests: this.stressTestsToUpdate }).subscribe(() => {
            this.submitModalHandler.emit();
            this.closeModal();
        });
    }
    openModal() {
        this.open = true;
        this.canUpdate = false;
        this.stressTestsToUpdate = cloneDeep(this.stressTests);
    }
    closeModal() {
        this.open = false;
    }
    initializeSortable() {
        const className = 'plate-container';
        this.ngZone.runOutsideAngular(() => {
            Sortable.create(this.sortableContainer.nativeElement, {
                handle: '.btn-reorder-up',
                scroll: false,
                forceFallback: true,
                animation: 150,
                onUpdate: (evt) => {
                    // The Sortable library is outside our Angular context, so we need to wrap
                    // our handler in a ngZone.run statement so that we are within a digest cycle.
                    this.ngZone.run(() => {
                        this.stressTestsToUpdate.splice(evt.newIndex, 0, this.stressTestsToUpdate.splice(evt.oldIndex, 1)[0]);
                        this.canUpdate = true;
                    });
                },
                onStart: () => {
                    disablePointerEvents(document, className);
                },
                onEnd: () => {
                    enablePointerEvents(document, className);
                },
            });
        });
    }
}
StressTestManageModalComponent.ɵfac = function StressTestManageModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StressTestManageModalComponent)(i0.ɵɵdirectiveInject(i1.StressTestService), i0.ɵɵdirectiveInject(i0.NgZone)); };
StressTestManageModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StressTestManageModalComponent, selectors: [["ycn-stress-test-manage-modal"]], viewQuery: function StressTestManageModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.confirmDeleteModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sortableContainer = _t.first);
    } }, inputs: { stressTests: "stressTests" }, outputs: { submitModalHandler: "submitModalHandler" }, standalone: false, decls: 22, vars: 11, consts: [["sortableContainer", ""], ["stressTestEditModal", ""], ["stressTestTemplateModal", ""], [3, "closeModalHandler", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section"], [1, "form-row", "user-select-none"], [1, "plates", "plates-view-list"], ["data-test-id", "stress-test", 3, "stressTest", "editHandler", "deleteHandler", 4, "ngFor", "ngForOf"], ["data-test-id", "no-stress-tests", 4, "ngIf"], [1, "divider-horizontal"], [1, "modal-footer", "user-select-none"], [1, "modal-footer-info"], [1, "modal-footer-actions"], [1, "btn", "btn-primary", 3, "click", "textContent"], [1, "btn", "btn-text", 3, "click", "textContent"], ["ycnDisabled", "", 1, "btn", "btn-primary", 3, "click", "textContent", "disabled"], [3, "submitModalHandler", "saveAfterSubmit"], [3, "submitModalHandler", "stressTestTemplates"], ["data-test-id", "stress-test", 3, "editHandler", "deleteHandler", "stressTest"], ["data-test-id", "no-stress-tests"]], template: function StressTestManageModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 3);
        i0.ɵɵlistener("closeModalHandler", function StressTestManageModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 4);
        i0.ɵɵlistener("closeModalHandler", function StressTestManageModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 5)(3, "div", 6)(4, "div", 7)(5, "div", 8, 0);
        i0.ɵɵtemplate(7, StressTestManageModalComponent_ycn_stress_test_manage_modal_list_item_7_Template, 1, 1, "ycn-stress-test-manage-modal-list-item", 9);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(8, StressTestManageModalComponent_p_8_Template, 2, 0, "p", 10);
        i0.ɵɵelement(9, "div", 11);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "div", 12)(11, "div", 13)(12, "div", 14)(13, "div", 15);
        i0.ɵɵlistener("click", function StressTestManageModalComponent_Template_div_click_13_listener() { i0.ɵɵrestoreView(_r1); const stressTestEditModal_r6 = i0.ɵɵreference(19); return i0.ɵɵresetView(stressTestEditModal_r6.openModal()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 15);
        i0.ɵɵlistener("click", function StressTestManageModalComponent_Template_div_click_14_listener() { i0.ɵɵrestoreView(_r1); const stressTestTemplateModal_r7 = i0.ɵɵreference(21); return i0.ɵɵresetView(stressTestTemplateModal_r7.openModal()); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(15, "div", 14)(16, "div", 16);
        i0.ɵɵlistener("click", function StressTestManageModalComponent_Template_div_click_16_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 17);
        i0.ɵɵlistener("click", function StressTestManageModalComponent_Template_div_click_17_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.submitModal()); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(18, "ycn-stress-test-edit-modal", 18, 1);
        i0.ɵɵlistener("submitModalHandler", function StressTestManageModalComponent_Template_ycn_stress_test_edit_modal_submitModalHandler_18_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.addStressTests([$event])); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "ycn-stress-test-template-selector-modal", 19, 2);
        i0.ɵɵlistener("submitModalHandler", function StressTestManageModalComponent_Template_ycn_stress_test_template_selector_modal_submitModalHandler_20_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.addStressTests($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.open);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Manage Stress Tests");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngForOf", ctx.stressTestsToUpdate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !(ctx.stressTestsToUpdate == null ? null : ctx.stressTestsToUpdate.length));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("textContent", "Add Custom");
        i0.ɵɵadvance();
        i0.ɵɵproperty("textContent", "Add Template");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("textContent", "Cancel");
        i0.ɵɵadvance();
        i0.ɵɵproperty("textContent", "Update")("disabled", !ctx.canUpdate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("saveAfterSubmit", true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("stressTestTemplates", ctx.stressTestTemplates);
    } }, dependencies: [i2.NgForOf, i2.NgIf, i3.DisabledDirective, i4.ModalBaseComponent, i5.SimpleModalHeaderComponent, i6.StressTestEditModalComponent, i7.StressTestTemplateSelectorModalComponent, i8.StressTestManageModalListItemComponent], encapsulation: 2 });
